import jwt from 'jsonwebtoken';
import CryptoJS from 'crypto-js';

export const formatPrivateKey = (privateKey: string): string => {
  const begin = '-----BEGIN RSA PRIVATE KEY-----\n';
  const end = '\n-----END RSA PRIVATE KEY-----';
  // Use a regular expression to insert newlines every 64 characters
  const formattedKey = privateKey.replace(/(.{64})/g, '$1\n');

  return `${begin}${formattedKey}${end}`;
};

export const createToken = (data: any, privatekey: any) => {

  const privateKey = privatekey
  const paramsOption: jwt.SignOptions = {
    algorithm: 'RS256',
    expiresIn: '2 days'
  };
  const formattedPrivateKey = formatPrivateKey(privateKey);
  const token = jwt.sign(data, formattedPrivateKey, paramsOption);
  return token;
};

// export const createToken = async (data: any): Promise<string> => {
//   const privateKey = import.meta.env.VITE_APP_SECRET_KEY

//   if (!privateKey) {
//     throw new Error("Private key is not defined")
//   }
//   const paramsOption: jwt.SignOptions = {
//     algorithm: 'RS256',
//     expiresIn: '2 days'
//   };
//   // console.log('formattedPrivateKey,',privateKey);
//   const formattedPrivateKey = formatPrivateKey(privateKey);
//   console.log("============================");
//   console.log("data",data);
//   console.log("formattedPrivateKey",formattedPrivateKey);
//   console.log("paramsOption",paramsOption);

//   const token: any = jwt.sign(data, formattedPrivateKey, paramsOption);
//   return token;
// }

export const encrypt = (data: any, encryptionKey?: any) => {
  const ivKey = encryptionKey || import.meta.env.VITE_APP_ENCRYPTION_KEY;
  if (ivKey) {
    const binaryEncryptionKey = CryptoJS.enc.Base64.parse(ivKey);
    const cipher = CryptoJS.AES.encrypt(data, binaryEncryptionKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return cipher.toString();
  }
};

// export const encrypt = (data: any): string => {
//   const ivKey = import.meta.env.VITE_APP_ENCRYPTION_KEY
//   if (!ivKey) {
//     throw new Error("Encryption key is not defined")
//   }

//   const binaryEncryptionKey = CryptoJS.enc.Base64.parse(ivKey)
//   const cipher = CryptoJS.AES.encrypt(data, binaryEncryptionKey, {
//     mode: CryptoJS.mode.ECB,
//     padding: CryptoJS.pad.Pkcs7,
//   })
//   return cipher.toString()
// }

export const decrypt = (data: any, encryptionKey?: any): string => {
  const ivKey = encryptionKey || import.meta.env.VITE_APP_ENCRYPTION_KEY;
  if (!ivKey) {
    throw new Error("Decryption key is not defined")
  }

  const binaryEncryptionKey = CryptoJS.enc.Base64.parse(ivKey);
  const bytes = CryptoJS.AES.decrypt(data, binaryEncryptionKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return bytes.toString(CryptoJS.enc.Utf8);

};

export const getDomainName = () => {
  const hostname = window.location.hostname; // Example: "billing.dmh.io-market.net"
  const parts = hostname.split(".");

  if (parts.length > 2) {
    // More than two parts exist (e.g., billing.dmh.io-market.net)
    return parts.slice(1).join("."); // "dmh.io-market.net"
  } else {
    // Only two parts (e.g., io-market.net)
    return hostname;
  }
};

export const getEncryptedItem = (item: string) => {
  if (item) {
    const encodedKey = btoa(item);
    const itemValue = localStorage.getItem(encodedKey);
    if (itemValue) {
      return atob(itemValue);
    }
  }
  return null;
};

export const setEncryptedItem = (item: string, itemValue: string) => {
  if (item && itemValue) {
    const encodedKey = btoa(item);
    const encodedValue = btoa(itemValue);
    localStorage.setItem(encodedKey, encodedValue);
    return true;
  }
  return false;
};

export const removeEncryptedItem = (item: string) => {
  if (item) {
    const encodedKey = btoa(item);
    localStorage.removeItem(encodedKey);
    return true;
  }
  return false;
};

//-----------------------------currency formater---------------------------------
export const formatCurrency = (amount:any) => {
  return new Intl.NumberFormat('de-CH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount || 0);
};

//-----------------------------Redirect To Accounts URL---------------------------------
export const redirectToAccounts = (subdomain = 'accounts',isLogout = false) => {
  localStorage.clear();
  let currentUrl = window.location.href;
  let urlObj = new URL(currentUrl);
  let domain = urlObj.hostname;
  let newDomain = domain.replace(/^[^.]+/, subdomain);
  let newUrl = `${urlObj.protocol}//${newDomain}`;
  if(subdomain==='bexio' && isLogout){
    newUrl = `${newUrl}/#/login/logout`;
  }
  window.location.href = newUrl;
};

export const setCookie = (name: string, value: any, expireDays: number, domain: string, path: string = '/') => {
  let d: Date = new Date();
  d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
  let expires: string = `expires=${d.toUTCString()}`;
  let cpath: string = path ? `; path=${path}` : '';
  document.cookie = `${name}=${value}; domain=${domain}; ${expires}${cpath};`;
};
